import { styled, Grid } from '@mui/material'

export const SearchWrapper = styled(Grid)(({ theme }) => ({
  flexShrink: 0,
  backgroundColor: 'white',
  padding: theme.spacing(0.5, 0, 2),
}))

export const SearchRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),

  '& > .MuiTextField-root': {
    flex: 1,
    minWidth: 0,
  },
}))

export const PaginationWrapper = styled(Grid)(({ theme }) => ({
  flexShrink: 0,
  backgroundColor: 'white',
  padding: theme.spacing(1, 0),
}))

export const ListWrapper = styled(Grid)(() => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  backgroundColor: 'white',
}))

export const Container = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  height: '100%',
  minHeight: 0,
  backgroundColor: 'white',
  overflow: 'hidden',
}))

export const ErrorWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  padding: theme.spacing(0, 1),
}))
